class Crypto {
    static createRandomUUID = () => {
        let id;

        if (crypto?.randomUUID) {
            id = crypto.randomUUID();
        } else {
            // eslint-disable-next-line no-bitwise
            id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                // eslint-disable-next-line no-bitwise
                (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
            );
        }

        return id;
    };
}

module.exports = Crypto;
